import React from 'react';
import Flickity from 'react-flickity-component'
import {filteredNodesAtom} from "../../../atoms/atoms";
import {useAtom} from "jotai";
import "flickity/css/flickity.css";
import ResultSliderItem from "./ResultSliderItem";
import styled from "styled-components/macro";
import colors from "../../../styles/variables/colors";
import {motion} from "framer-motion";

type ResultSliderComponent = () => JSX.Element;

const SliderWrapper = styled(motion.div)`
  background-color: ${colors.slate["10"]};
  padding:  50px 30px;
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }

  .flickity-button {
    top: auto;
    transform: none;
    background: none;
  }

  .flickity-button[disabled='true'] {
    opacity: 0;
  }
`;

const ResultSlider: ResultSliderComponent = () => {

  const [nodes] = useAtom(filteredNodesAtom);
  const enableSlider = nodes.length > 3;

  return (
    <SliderWrapper style={{ height: enableSlider ? 450 : 420, paddingBottom: enableSlider ? 30 : 30}}>
      <Flickity reloadOnUpdate={false} options={{
        freeScroll: enableSlider,
        draggable: enableSlider,
        pageDots: enableSlider,
        cellAlign: 'center',
        groupCells: true,
        lazyLoad: false,
        imagesLoaded: false,
        setGallerySize: true,
        adaptiveHeight: false,
        contain: true,
      }}>
        {
          nodes.map(node => {
            return <ResultSliderItem node={node} key={`slider_item_${node.id}`}/>
          })
        }
      </Flickity>
    </SliderWrapper>
  )
}
export default ResultSlider;
